import { useState, useMemo, useCallback } from "react";
import GDLWidgetAppProd from "@deere/gdl-widget-test-2_0/dist/gdl-widget-2_0";
import "@deere/gdl-widget-test-2_0/dist/widget.css";
//import "@deere/gdl-widget-2_0/dist/widget.css";
//import GDLWidgetAppProd from "@deere/gdl-widget-2_0";
import Typography from '@mui/material/Typography';
import { Store } from './Store';
import { ChevronRight } from './ChevronRight';
import './App.css';

function GDLWidgetFormNew() {

    const [inputs, setInputs] = useState({});
    const [selectedIndustries, setSelectedIndustries] = useState([]);
    
    // Separate state for widget configuration - only updated when button is clicked
    const [widgetConfig, setWidgetConfig] = useState({});
    const [widgetIndustries, setWidgetIndustries] = useState([]);

    // Memoize getDealerData function to prevent unnecessary re-renders
    const getDealerData = useCallback((dealer) => {
        document.getElementById("dealer-json").innerHTML = JSON.stringify(dealer)
    }, []);

    // Memoize icon elements to prevent unnecessary re-renders
    const startIcon = useMemo(() => <Store />, []);
    const endIcon = useMemo(() => <ChevronRight />, []);
    
    // Memoize sx object to prevent unnecessary re-renders
    const sxStyle = useMemo(() => ({ width: "75%" }), []);

    // Memoize indicatorMap to prevent unnecessary re-renders
    const indicatorMap = useMemo(() => ({
        "sale": widgetConfig.saleRequired !== undefined ? widgetConfig.saleRequired : undefined,
        "service": widgetConfig.serviceRequired !== undefined ? widgetConfig.serviceRequired : undefined,
        "parts": widgetConfig.partsRequired !== undefined ? widgetConfig.partsRequired : undefined
    }), [widgetConfig.saleRequired, widgetConfig.serviceRequired, widgetConfig.partsRequired]);

    // Memoize agreementCodes to prevent unnecessary re-renders
    const agreementCodes = useMemo(() => 
        widgetConfig.agreementCodes !== undefined 
            ? widgetConfig.agreementCodes.split(',').map(code => code.trim()).filter(code => code) 
            : undefined
    , [widgetConfig.agreementCodes]);

    // Handler to apply form configuration to widget
    const applyConfiguration = useCallback(() => {
        setWidgetConfig({...inputs});
        setWidgetIndustries([...selectedIndustries]);
    }, [inputs, selectedIndustries]);

    const handleChangeSelected = (event) => {
        const value = parseInt(event.target.value);
        if (event.target.checked) {
            setSelectedIndustries(prev => [...prev, value]);
        } else {
            setSelectedIndustries(prev => prev.filter(industry => industry !== value));
        }
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }))
    }

    const hanldleChangeForBooleanValues = (event) => {
        const name = event.target.name;
        const value = event.target.value === "true" ? true : false;
        setInputs(values => ({ ...values, [name]: value }))
    }

    return (
        <><Typography align="center"><b><br></br>GDL Widget 2.0 Test Form</b></Typography><table border="1px" align="center">
            <tbody>
                <tr>
                    <td>
                        <form>
                            <p><b>Enter Address</b>&nbsp;&nbsp;<br />
                                <textarea autocomplete="off" id="address" name="address" rows="2" cols="50" value={inputs.address} onChange={handleChange}></textarea>
                            </p>
                            <p><b>Select Industry:&nbsp;&nbsp;</b><br></br>
                                <select name="productGroupId" id="productGroupId" onChange={handleChange}>
                                    <option >select from dropdown</option>
                                    <option value="7">Agriculture</option>
                                    <option value="2">Construction</option>
                                    <option value="6">Lawn & Garden</option>
                                    <option value="4">Forestory</option>
                                    <option value="5">Golf & Sports</option>
                                    <option value="88">Tractor Compact - 20-66 engine hp</option>
                                    <option value="87">Tractor SSmall - 45-125 engine hp</option>
                                    <option value="89">Gator Utility Vehicle</option>
                                    <option value="86">Landscape & Grounds Care</option>
                                    <option value="60">Compact Construction Equipment</option>
                                    <option value="18">Industrial Engines – Sales</option>
                                    <option value="21">Marine Engines - Sales & Service</option>
                                    <option value="27">Funk Drivetrain - Sales</option>
                                    <option value="28">Funk Drivetrain - Service</option>
                                    <option value="74">Engines (Off-Highway), Industrial - Service</option>
                                    <option value="104">Wirtgen Group</option>
                                </select></p>
                            <p><b>Enter countryCode for country restriction</b>&nbsp;&nbsp;<br></br>
                                <textarea id="countryCode" name="countryCode" rows="1" cols="50" value={inputs.countryCode} onChange={handleChange}></textarea></p>
                            <p><b>Enter locale</b>&nbsp;&nbsp;<br></br>
                                <textarea id="locale" name="locale" rows="1" cols="50" value={inputs.locale} onChange={handleChange}></textarea></p>
                            <p><b>Parts Dealer Primary Email Address Required: &nbsp;&nbsp;</b> <br></br>
                                <select name="partsDealerEmailRequired" id="partsDealerEmailRequired" value={inputs.partsDealerEmailRequired} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                            <p><b>Required sales dealers: &nbsp;&nbsp;</b> <br></br>
                                <select name="saleRequired" id="saleRequired" value={inputs.saleRequired} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                            <p><b>Required Parts dealers: &nbsp;&nbsp;</b> <br></br>
                                <select name="partsRequired" id="partsRequired" value={inputs.partsRequired} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                            <p><b>Required Service dealers: &nbsp;&nbsp;</b> <br></br>
                                <select name="serviceRequired" id="serviceRequired" value={inputs.serviceRequired} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                            <p><b>New Cog View Progress: &nbsp;&nbsp;</b> <br></br>
                                <select name="cogView" id="cogView" value={inputs.cogView} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                            <p><b>DealerID For COG</b>&nbsp;&nbsp;<br />
                                <textarea id="cogId" name="cogId" rows="1" cols="50" value={inputs.cogId} onChange={handleChange}></textarea>
                            </p>
                             <p><b>DealerID For DOG</b>&nbsp;&nbsp;<br />
                                <textarea id="dogId" name="dogId" rows="1" cols="50" value={inputs.dogId} onChange={handleChange}></textarea>
                            </p>
                            <p><b>Product Code for Ecommerce</b>&nbsp;&nbsp;<br />
                                <textarea id="productCode" name="productCode" rows="1" cols="50" value={inputs.productCode} onChange={handleChange}></textarea>
                            </p>
                            <p><b>Product Quantity for Ecommerce</b>&nbsp;&nbsp;<br />
                                <textarea id="quantity" name="quantity" rows="1" cols="50" value={inputs.quantity} onChange={handleChange}></textarea>
                            </p>
                            <p><b>Enter Dealer IDs</b><br></br>
                                <textarea id="dealerIds" name="dealerIds" rows="2" cols="50" value={inputs.dealerIds} onChange={handleChange}></textarea></p>
                            <p><b>Pre-Selected Dealer Required: &nbsp;&nbsp;</b> <br></br>
                                <select name="enablePreselectDealerData" id="enablePreselectDealerData" value={inputs.enablePreselectDealerData} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                            <p><b>Is Non Deere Dealer Required: &nbsp;&nbsp;</b> <br></br>
                                <select name="showNonDeereDealer" id="showNonDeereDealer" value={inputs.showNonDeereDealer} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                                <p><b>Is Purchase part Button Required: &nbsp;&nbsp;</b> <br></br>
                                <select name="showPurchaseParts" id="showPurchaseParts" value={inputs.showPurchaseParts} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                                <p><b>Select false if location access should be denied: &nbsp;&nbsp;</b> <br></br>
                                <select name="enableLocation" id="enableLocation" value={inputs.enableLocation} onChange={hanldleChangeForBooleanValues}>
                                    <option >select from dropdown</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></p>
                                <p><b>Agreement Codes (comma-separated)</b>&nbsp;&nbsp;<br />
                                    <textarea id="agreementCodes" name="agreementCodes" rows="1" cols="50" value={inputs.agreementCodes} onChange={handleChange}></textarea>
                                </p>
                                <p><b>Product Name</b>&nbsp;&nbsp;<br />
                                    <textarea id="productName" name="productName" rows="1" cols="50" value={inputs.productName} onChange={handleChange}></textarea>
                                </p>
                                <p><b>Search Type</b>&nbsp;&nbsp;<br />
                                    <select name="searchBy" id="searchBy" value={inputs.searchBy} onChange={handleChange}>
                                        <option>select from dropdown</option>
                                        <option value="street">street</option>
                                        <option value="city">city</option>
                                    </select>
                                </p>
                                <p><b>Environment: &nbsp;&nbsp;</b> <br></br>
                                <select name="env" id="env" value={inputs.env} onChange={handleChange}>
                                    <option >select from dropdown</option>
                                    <option value="devl">devl</option>
                                    <option value="cert">cert</option>
                                    <option value="prod">prod</option>
                                </select></p>
                            <p><b>Theme: &nbsp;&nbsp;</b> <br></br>
                                <select name="theme" id="theme" value={inputs.theme} onChange={handleChange}>
                                    <option >select from dropdown</option>
                                    <option value="enterprise">enterprise (default)</option>
                                    <option value="construction">construction</option>
                                </select></p>
                            <p><b>GDL Button Color: &nbsp;&nbsp;</b> <br></br>
                                <select name="gdlButtonColor" id="gdlButtonColor" value={inputs.gdlButtonColor} onChange={handleChange}>
                                    <option value="onLight">onLight (default)</option>
                                    <option value="onDark">onDark</option>
                                </select></p>
                            <p><b>Industry Filter&nbsp;</b></p>
                            <div>Select the Industries you want on GDL widget</div>
                            <div>
                                <div>
                                    <div className="checkbox-pair">
                                        <label><input type="checkbox" value={7} onChange={handleChangeSelected} />Agriculture</label>
                                        <label><input type="checkbox" value={2} onChange={handleChangeSelected} />Construction</label>
                                    </div>
                                    <div className="checkbox-pair">
                                        <label><input type="checkbox" value={6} onChange={handleChangeSelected} />Lawn And Garden</label>
                                        <label><input type="checkbox" value={4} onChange={handleChangeSelected} />Forestry</label>
                                    </div>
                                    <div className="checkbox-pair">
                                        <label><input type="checkbox" value={5} onChange={handleChangeSelected} />Golf & Sports</label>
                                        <label><input type="checkbox" value={3} onChange={handleChangeSelected} />Engines & Drivetrain</label>
                                    </div>
                                    <div className="checkbox-pair">
                                        <label><input type="checkbox" value={59} onChange={handleChangeSelected} />Tractor Compact - 20-66 engine hp</label>
                                        <label><input type="checkbox" value={53} onChange={handleChangeSelected} />Tractor Small - 45-125 engine hp</label>
                                    </div>
                                    <div className="checkbox-pair">
                                        <label><input type="checkbox" value={29} onChange={handleChangeSelected} />Gator Utility Vehicle</label>
                                        <label><input type="checkbox" value={97} onChange={handleChangeSelected} />Landscape & Grounds Care</label>
                                    </div>
                                    <div className="checkbox-pair">
                                        <label><input type="checkbox" value={60} onChange={handleChangeSelected} />Compact Construction Equipment</label>
                                        <label><input type="checkbox" value={104} onChange={handleChangeSelected} />Wirtgen Group</label>
                                    </div>
                                    {/* Add more checkbox pairs as needed */}
                                </div>
                            </div>
                            <p style={{ marginTop: '20px' }}>
                                <button type="button" onClick={applyConfiguration} style={{ 
                                    padding: '10px 20px', 
                                    backgroundColor: '#367c2b', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px', 
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}>
                                    Apply Configuration to Widget
                                </button>
                            </p>
                        </form>
                        <br />
                        <GDLWidgetAppProd
                            key="widget-primary-1"
                            getDealerData={getDealerData}
                            variant={'primary'}
                            startIcon={startIcon}
                            endIcon={endIcon}
                            buttonText={"Fuel React Button"}
                            isCoreMediaEnabled={true}
                            enablePreselectDealerData={widgetConfig.enablePreselectDealerData !== undefined ? widgetConfig.enablePreselectDealerData : undefined}
                            editbutton={true}
                            sx={sxStyle}
                            countryCode={widgetConfig.countryCode !== undefined ? widgetConfig.countryCode : undefined}
                            locale={widgetConfig.locale !== undefined ? widgetConfig.locale : undefined}
                            address={widgetConfig.address !== undefined ? widgetConfig.address : undefined}
                           productGroupId={widgetConfig.productGroupId !== undefined ? parseInt(widgetConfig.productGroupId) : undefined}
                            dealerIds={widgetConfig.dealerIds !== undefined ? widgetConfig.dealerIds : undefined}
                            partsDealerEmailRequired={widgetConfig.partsDealerEmailRequired !== undefined ? widgetConfig.partsDealerEmailRequired : undefined}
                            showNonDeereDealer={widgetConfig.showNonDeereDealer !== undefined ? widgetConfig.showNonDeereDealer : undefined}
                            filteredIndustries={widgetIndustries}
                            cogView={widgetConfig.cogView !== undefined ? widgetConfig.cogView : undefined}
                            cogId={widgetConfig.cogId !== undefined ? widgetConfig.cogId : undefined}
                            dogId={widgetConfig.dogId !== undefined ? widgetConfig.dogId : undefined}
                            productCode={widgetConfig.productCode !== undefined ? widgetConfig.productCode : undefined}
                            quantity={widgetConfig.quantity !== undefined ? parseInt(widgetConfig.quantity) : undefined}
                            indicatorMap={indicatorMap}
                            enableLocation={widgetConfig.enableLocation !== undefined ? widgetConfig.enableLocation : undefined}
                            showPurchaseParts={widgetConfig.showPurchaseParts !== undefined ? widgetConfig.showPurchaseParts : undefined}
                            agreementCodes={agreementCodes}
                            productName={widgetConfig.productName !== undefined ? widgetConfig.productName : undefined}
                            env={widgetConfig.env !== undefined ? widgetConfig.env : undefined}
                            searchBy={widgetConfig.searchBy || "street"}
                            theme={widgetConfig.theme}
                            gdlButtonColor={widgetConfig.gdlButtonColor}
                            showDealerNameOnButton={true}
                        />
                    </td>
                </tr>
            </tbody>

        </table>
            <br></br>
            <p id="dealer-json"></p>
        </>

    )
}

export default GDLWidgetFormNew;
